module.exports = __webpack_public_path__ + "img/KSC08768 (2).6a733864.jpg";